(() => {
  const tr = window.fecoTranslate || (text => text);
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const visitVariants = new Set(['54440510488917', '54440522776917']);
  const isBooking = item => {
    const p = item.properties || {};
    return Boolean(p._feco_hold_id || p._feco_hold_token || p['Reserva FECO'] || visitVariants.has(String(item.variant_id)));
  };
  const isValid = item => {
    const p = item.properties || {};
    return Boolean(p._feco_hold_id && p._feco_hold_token && p.Fecha && p.Hora &&
      Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 8 &&
      String(p.Personas) === String(item.quantity));
  };
  const errorEl = () => document.getElementById('cart-errors');
  const message = text => { if (errorEl()) errorEl().textContent = tr(text); };
  let busy = false;
  let allowedSubmit = false;
  const paymentButtons = () => [...document.querySelectorAll('[name="checkout"]')];
  const setBusy = value => {
    busy = value;
    paymentButtons().forEach(button => {
      if (value) {button.dataset.fecoPreviouslyDisabled = String(button.disabled);button.disabled = true;}
      else {button.disabled = button.dataset.fecoPreviouslyDisabled === 'true';delete button.dataset.fecoPreviouslyDisabled;}
    });
  };
  const loadCart = async () => {
    const response = await fetch(`${root()}cart.js`, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('No se pudo comprobar el carrito. Inténtalo de nuevo.');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('No se pudo comprobar el carrito.');
    return cart;
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-feco-change-people]');
    if (!button) return;
    event.preventDefault();
    if (busy) return;
    const status = button.closest('.feco-cart-booking-note')?.querySelector('[data-feco-cart-row-status]');
    setBusy(true);
    button.disabled = true;
    try {
      if (status) status.textContent = tr('Retirando esta visita del carrito...');
      const cart = await loadCart();
      const item = cart.items.find(line => line.key === button.dataset.fecoLineKey);
      if (!item || !isBooking(item)) throw new Error('El carrito ha cambiado. Recarga la página antes de modificar la visita.');
      const response = await fetch(`${root()}cart/change.js`, {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:item.key,quantity:0})
      });
      const updated = await response.json();
      if (!response.ok || updated.errors || !Array.isArray(updated.items) || updated.items.some(line => line.key === item.key)) {
        throw new Error('No se pudo retirar la visita. El carrito no se ha confirmado; recarga antes de continuar.');
      }
      window.location.assign(`${root()}pages/visitas#reservas-online`);
    } catch (error) {
      if (status) status.textContent = tr(error.message);
      message(error.message);
      button.disabled = false;
      setBusy(false);
    }
  });
  document.addEventListener('submit', async event => {
    if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout') return;
    if (allowedSubmit) {allowedSubmit = false;return;}
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    if (document.querySelector('.cart__items--disabled')) {
      message('Espera a que termine de actualizarse el carrito antes de pagar.');
      return;
    }
    const form = event.target;
    const button = event.submitter;
    setBusy(true);
    message('Comprobando las plazas antes del pago...');
    try {
      const cart = await loadCart();
      if (!cart.items.length || cart.items.some(item => isBooking(item) && !isValid(item))) {
        throw new Error('La cantidad no coincide con las personas reservadas. Usa Cambiar personas o fecha para volver al calendario.');
      }
      // The server cart is authoritative; do not submit stale updates[] values from another tab.
      const stale = [...form.querySelectorAll('[name="updates[]"]')].some(input => {
        const item = cart.items.find(line => line.key === input.dataset.quantityLineKey);
        return !item || Number(input.value) !== item.quantity;
      });
      if (stale) throw new Error('El carrito ha cambiado. Recarga la página para ver las plazas y el total actuales antes de pagar.');
      setBusy(false);
      message('');
      allowedSubmit = true;
      form.requestSubmit(button);
    } catch (error) {
      allowedSubmit = false;
      message(error.message);
      setBusy(false);
    }
  }, true);
})();
